import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT = { primary_color: "#6D28D9", accent_color: "#F59E0B", admin_dark: true, dark_color: "#130F26", school_name: "SPARKORA EDU", tagline: "School Management System", logo_url: "" };
const ThemeContext = createContext({ theme: DEFAULT, refresh: () => {} });

function shade(hex, pct) {
  const n = parseInt(hex.slice(1), 16);
  const f = (c) => Math.max(0, Math.min(255, Math.round(c + (pct < 0 ? c : 255 - c) * pct)));
  const r = f(n >> 16), g = f((n >> 8) & 255), b = f(n & 255);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

export function applyTheme(t) {
  const root = document.documentElement.style;
  root.setProperty("--brand", t.primary_color);
  root.setProperty("--brand-dark", shade(t.primary_color, -0.35));
  root.setProperty("--brand-light", shade(t.primary_color, 0.88));
  root.setProperty("--brand-accent", t.accent_color);
  const dark = t.dark_color || "#130F26";
  root.setProperty("--dark-bg", dark);
  root.setProperty("--dark-deep", shade(dark, -0.3));
  root.setProperty("--dark-surface", shade(dark, 0.06));
  root.setProperty("--dark-raised", shade(dark, 0.12));
  root.setProperty("--dark-line", shade(dark, 0.2));
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(DEFAULT);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/theme");
      setTheme(data);
      applyTheme(data);
    } catch { applyTheme(DEFAULT); }
  }, []);
  useEffect(() => { applyTheme(DEFAULT); refresh(); }, [refresh]);
  return <ThemeContext.Provider value={{ theme, refresh, setTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
export const isAdminRole = (role) => role === "master_admin" || role === "super_admin";
